import { chakra } from "@chakra-ui/react"
import { Form as FormikForm } from "formik"

export default chakra(FormikForm)
